<template>
    <div>
        <x-checkbox-wrapper label="Aktifkan trigger">
            <input type="checkbox" v-model="fields.active" />
        </x-checkbox-wrapper>
        <x-panel v-if="fields.active">
            <div class="col-xs-12">
                <x-form-group :horizontal="false" label="Dari Kategori" :error="getError(`${errorPrefix}initial_categories`)">
                    <x-input-group-categories v-model="fields.initial_categories" />
                </x-form-group>
                <x-form-group :horizontal="false" label="Dari Group" :error="getError(`${errorPrefix}initial_groups`)">
                    <x-input-groups v-model="fields.initial_groups" />
                </x-form-group>
                <x-form-group :horizontal="false" label="Status" :error="getError(`${errorPrefix}initial_status`)">
                    <x-input-member-statuses v-model="fields.initial_status" />
                </x-form-group>
                <x-form-group :horizontal="false" label="Ubah Ke" :error="getError(`${errorPrefix}update_to`)" :isRequired="true">
                    <x-input-member-status v-model="fields.update_to" />
                </x-form-group>
            </div>
        </x-panel>
    </div>
</template>

<script>
import FormErrorMixin from '../mixins/FormErrorMixin'
import XCheckboxWrapper from './XCheckboxWrapper.vue'
import XFormGroup from './XFormGroup.vue'
import XInputGroupCategories from './XInputGroupCategories.vue'
import XInputGroups from './XInputGroups.vue'
import XInputMemberStatus from './XInputMemberStatus.vue'
import XInputMemberStatuses from './XInputMemberStatuses.vue'
import XPanel from './XPanel.vue'
export default {
    components: { XPanel, XFormGroup, XInputGroupCategories, XInputGroups, XInputMemberStatuses, XInputMemberStatus, XCheckboxWrapper },
    created() {
        if (this.initialFields) {
            this.fields = { 
                ...this.fields, 
                ...this.formatInput(this.initialFields),
            };
        }
    },
    data() {
        return {
            fields: {
                active: false,
                initial_categories: [],
                initial_groups: [],
                initial_status: [],
                update_to: null,
            }
        };
    },
    methods: {
        formatInput(fields) {
            return Object.keys(fields).reduce((input, key) => {
                return { 
                    ...input,
                    [key]: fields[key] === null ? [] : fields[key],
                };
            }, {});
        },
        formatOutput(fields) {
            if (this.returnNullIfInactive && !this.fields.active) {
                return null;
            }
            if (!this.treatEmptyArrayAsNull) {
                return fields;
            }
            return Object.keys(fields).reduce((output, key) => {
                return { 
                    ...output,
                    [key]: Array.isArray(fields[key]) && fields[key].length === 0 ? null : fields[key],
                };
            }, {});
        }
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        errors: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        errorPrefix: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        returnNullIfInactive: {
            type: Boolean,
            required: false,
            default: true,
        },
        treatEmptyArrayAsNull: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    watch: {
        fields: {
            handler(fields) {
                this.$emit('input', this.formatOutput(fields));  
            },
            deep: true,
        }
    }
}
</script>